import { LOG_OUT } from '../auth/actionTypes';
import {
	ADD_EVENTS_SUCCESS,
	CLEAR_SESSION,
	EDIT_EVENTS_SUCCESS,
	EVENTS_STATUS,
	FETCH_EVENTS,
	FETCH_EVENTS_COUNT,
} from './actionTypes';

const PAGE_SIZE = 15;

const initState = {
	events: [],
	count: 0,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_EVENTS:
			return {
				...state,
				events: action.events,
			};
		case FETCH_EVENTS_COUNT:
			return {
				...state,
				count: action.count,
			};
		case ADD_EVENTS_SUCCESS: {
			return {
				...state,
				events: [action.newEvent, ...state.events].slice(0, PAGE_SIZE),
				count: state.count + 1,
			};
		}
		case EDIT_EVENTS_SUCCESS: {
			let eventsList = state.events.map((element) =>
				element.id !== action.events.id ? { ...element } : { ...action.events }
			);
			return {
				...state,
				events: eventsList,
			};
		}
		case EVENTS_STATUS: {
			let eventsList = state.events.map((element) => {
				return element.id !== action.id ? { ...element } : { ...element, active: !element.active };
			});
			return {
				...state,
				events: eventsList,
			};
		}

		case LOG_OUT:
		case CLEAR_SESSION:
			return initState;
		default:
			return state;
	}
};

export default reducer;
